/*global define:false*/
define('addContentViewConfig',['addContentViewModel'], function (addContentModel) {
    'use strict';

    return {
        name : 'addContent',
        ModelType : addContentModel,
        browserTitle : 'Content',
        modelData : {},
        permissions : ['admin', 'editor']
    };
});

